import { render } from "./EdicionPerfilVelocidad.vue?vue&type=template&id=6d7883c0&scoped=true"
import script from "./EdicionPerfilVelocidad.vue?vue&type=script&lang=js"
export * from "./EdicionPerfilVelocidad.vue?vue&type=script&lang=js"

import "./EdicionPerfilVelocidad.vue?vue&type=style&index=0&id=6d7883c0&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7883c0"]])

export default __exports__